<script>
    import { createEventDispatcher } from "svelte";
    import ProfilePicker from "./ProfilePicker.svelte";

    export let index = 0;

    const dispatch = createEventDispatcher();

    function didSelectProfile(e) {
        dispatch("profile", { profile: e.detail.profile });
    }
</script>

{#if index === 0}
    <div class="step">
        <h1>Welcome to America!</h1>
        <p>
            Safari, Chrome, Explorer. These are gateways to the infinite corners
            of the internet. America is your gateway to another kind of
            sprawling terrain, where there’s just as much to learn.
        </p>
    </div>
{:else if index === 1}
    <div class="step">
        <h1>Vehicle Options</h1>
        <p>
            Choose your vehicle and we’ll get you going on your route. Once your
            journey begins, you’re able to configure your dashboard from
            America’s roadtrip suite of features, each offering a unique way of
            experiencing the country.
        </p>
    </div>
{:else if index === 2}
    <div class="step">
        <h1>Vehicle Options</h1>
        <p>Choose according to personal preference:</p>
        <ProfilePicker on:change={didSelectProfile} />
    </div>
{:else if index === 3}
    <div class="step">
        <h1>Take it on the road</h1>
        <p>
            From local classifieds and radio stations to a walkie talkie that
            connects you with other drivers, you’re bound to discover something
            new from every trip.
        </p>
        <div class="counter">1 / 7</div>
    </div>
{:else if index === 4}
    <div class="step">
        <h1>Welcome to America!</h1>
        <p>
            As you near your third or fourth day of your drive, you find
            yourself surrendering to the land in a way you couldn’t have
            anticipated when you first set out, just like you weren’t sure how
            far that first tank of gas would get you. Now you know.
        </p>
        <p>
            By this point, the country starts to contract. The difference
            between Kansas and Colorado or Ohio and Pennsylvania was mostly in
            your head. America as you imagined it—illustrated on a map,
            fragmented by state lines—boils down to a fluid mass of earth. On
            the road, it feels more conquerable. It feels continuous.
        </p>
        <div class="counter">2 / 7</div>
    </div>
{:else if index === 5}
    <div class="step">
        <h1>Welcome to America!</h1>
        <p>
            Then it expands again. It’s somehow the little things that make it
            feel bigger. The used electronics store in Utah, where you buy the
            Twister soundtrack for your upcoming stretch across Kansas. The
            parking lot in Arkansas, where you happen to pull up right next to
            the same orange Prius-C as yours. You spot a cluster of Mardi Gras
            beads through the windshield, danging from the mirror like a rosary,
            making sense of the Louisiana license plate. Or the eccentric table
            shaped as an iguana that showed up in the classifieds in North
            Dakota, identical to the one in your parents’ basement in Western
            New York.
        </p>
        <div class="counter">3 / 7</div>
    </div>
{:else if index === 6}
    <div class="step">
        <h1>Welcome to America!</h1>
        <p>
            The details help ground you in otherwise unfamiliar territory, but
            remind you of the density surrounding you. You learn to embrace it.
            Take some of it with you. Leave a lot of it behind. For the latter
            bunch, it feels as though it’ll always be there. Naturally, too,
            like a thousand-year-old redwood in Northern California.
        </p>
        <p>
            You learn a lot from these details. From the diners you stop at and
            the local radio stations you let soundtrack your drive.
        </p>
        <div class="counter">4 / 7</div>
    </div>
{:else if index === 7}
    <div class="step">
        <h1>Welcome to America!</h1>
        <p>
            America is like encountering a collection of used postcards in an
            antiques shop. On the front of the postcard is an image, depicting
            scenery or a notable momunent that anyone can call their own. On the
            back is a note handwritten by someone you don’t know, addressed to
            somewhere you’ve never been. The sender had experienced a slice of
            America in a very personal way. Having come this far, you almost see
            yourself in the words.
        </p>
        <div class="counter">5 / 7</div>
    </div>
{:else if index === 8}
    <div class="step">
        <h1>Welcome to America!</h1>
        <p>
            In this way, America becomes a mirror, if you’re willing to look
            long and close enough. Its roads are a perfect place to reflect. You
            see yourself on every page. Every state. Every town. Every little
            street. For as much as there is to digest from all the places you’ve
            encountered, America begins to take on an unwritten quality. Its
            story is still unfolding, alongside yours.
        </p>
        <div class="counter">6 / 7</div>
    </div>
{:else if index === 9}
    <div class="step">
        <h1>Welcome to America!</h1>
        <p>
            Whatever your trip becomes, remember these few things. Buckle up.
            Mind the speed limit. Keep your eyes on the road. Make sure to check
            in from time to time with those you love. And enjoy yourself.
        </p>
    </div>
{/if}

<style>
    .step * {
        font-size: 13px;
    }

    .counter {
        margin-top: 13px;
        font-size: 11px;
    }
</style>
